/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskcategory3Inputs */

const en_aiflowaskcategory3 = /** @type {(inputs: Aiflowaskcategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which category fits the event?`)
};

const de_aiflowaskcategory3 = /** @type {(inputs: Aiflowaskcategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu welcher Kategorie passt das Event?`)
};

/**
* | output |
* | --- |
* | "Which category fits the event?" |
*
* @param {Aiflowaskcategory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskcategory3 = /** @type {((inputs?: Aiflowaskcategory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskcategory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskcategory3(inputs)
	return de_aiflowaskcategory3(inputs)
});
export { aiflowaskcategory3 as "aiFlowAskCategory" }